import { render, staticRenderFns } from "./OutStockOrderList.vue?vue&type=template&id=36f820ba&"
import script from "./OutStockOrderList.vue?vue&type=script&lang=js&"
export * from "./OutStockOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports